import Enumerator from '../global/Enumerator';

export const assetFinanceVendorTypes = [
  'none',
  'dealer',
  'franchised_dealer',
  'private',
  'refinance',
  'buyback',
  'rollover',
  'capital_raising'
];

export class AssetFinanceVendorType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
      case 'v1':
        correctOption = 'dealer';
        break;
      case '2':
        correctOption = 'franchised_dealer';
        break;
      case '3':
      case 'v3':
        correctOption = 'private';
        break;
      case '4':
        correctOption = 'refinance';
        break;
      case '5':
        correctOption = 'buyback';
        break;
      case '6':
        correctOption = 'rollover';
        break;
      case '7':
        correctOption = 'capital_raising';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

AssetFinanceVendorType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  dealer: {
    get title() {
      return 'Dealer';
    }
  },
  franchised_dealer: {
    get title() {
      return 'Franchised dealer';
    }
  },
  private: {
    get title() {
      return 'Private';
    }
  },
  refinance: {
    get title() {
      return 'Refinance';
    }
  },
  buyback: {
    get title() {
      return 'Buyback';
    }
  },
  rollover: {
    get title() {
      return 'Rollover';
    }
  },
  capital_raising: {
    get title() {
      return 'Capital raising';
    }
  }
});

export default {
  assetFinanceVendorTypes,
  AssetFinanceVendorType
};
